module.exports = __webpack_public_path__ + "assets/img/facebook_b.e4299c1d.svg";